import { render } from "./Deliveries.vue?vue&type=template&id=5bffa433"
import script from "./Deliveries.vue?vue&type=script&lang=js"
export * from "./Deliveries.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/geramyan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__